import { themeTokens } from "@octopusdeploy/design-system-tokens";
import type { Segment, TenantResource, FeatureToggleEnvironmentResource, EnvironmentV2Resource } from "@octopusdeploy/octopus-server-client";
import { DEFAULT_COLOR } from "~/areas/library/components/TenantTagSets/TagListEdit/TagListEdit";
import Chip from "~/components/Chips/Chip";
import { TenantChip, tenantChipList } from "~/components/Chips/index";
import Tag from "~/components/Tag/index";
import { useOctopusTheme } from "~/components/Theme/index";
import type { TagIndex } from "~/components/tagSets";
import EnvironmentOrMissingChip from "./EnvironmentOrMissingChip";
interface FeatureToggleEnvironmentProps {
    featureToggleEnvironment: FeatureToggleEnvironmentResource;
    environments: EnvironmentV2Resource[];
    tenants: TenantResource[];
    tagIndex: TagIndex;
}
interface SegmentListProps {
    segments: Segment[];
}
interface ExcludedTenantListProps {
    excludedTenants: TenantResource[];
}
function formatSegment(segment: Segment) {
    return `${segment.Key}/${segment.Value}`;
}
export function SegmentList({ segments }: SegmentListProps) {
    const theme = useOctopusTheme();
    return (<>
            {segments.map((segment) => (<Tag tagName={formatSegment(segment)} description={""} tooltipLabel={"Segment"} tagColor={theme.info} key={formatSegment(segment)}/>))}
        </>);
}
export function ExcludedTenantList({ excludedTenants }: ExcludedTenantListProps) {
    const theme = useOctopusTheme();
    return (<>
            {excludedTenants.map((tenant) => (<TenantChip tenantName={tenant.Name} backgroundColor={theme.alertCalloutBackground} key={tenant.Id} markAsRemoved={true}/>))}
        </>);
}
interface TagChipsFromTagNamesProps {
    canonicalTagNames: string[];
    tagIndex: TagIndex;
    markAsRemoved?: boolean;
}
export function TagChipsFromTagNames({ canonicalTagNames, tagIndex, markAsRemoved = false }: TagChipsFromTagNamesProps) {
    const tags = canonicalTagNames.map((tagName) => tagIndex[tagName] || { CanonicalTagName: tagName, Color: DEFAULT_COLOR });
    return (<>
            {tags.map((tag, index) => (<Chip backgroundColor={tag.Color} labelColor={themeTokens.color.text.inverse.primary} markAsRemoved={markAsRemoved} key={index}>
                    {tag.CanonicalTagName}
                </Chip>))}
        </>);
}
export default ({ featureToggleEnvironment, environments, tenants, tagIndex }: FeatureToggleEnvironmentProps) => {
    const theme = useOctopusTheme();
    return (<span>
            <EnvironmentOrMissingChip environmentId={featureToggleEnvironment.DeploymentEnvironmentId} environments={environments}/>
            {featureToggleEnvironment.TenantTargetingStrategy === "SpecificTenants" && (<>
                    {tenantChipList(tenants, featureToggleEnvironment.TenantIds)}
                    {featureToggleEnvironment.RolloutPercentage === null ? null : <Chip backgroundColor={theme.experimentBackground}>{featureToggleEnvironment.RolloutPercentage}% of tenants</Chip>}
                    <TagChipsFromTagNames canonicalTagNames={featureToggleEnvironment.TenantTags} tagIndex={tagIndex}/>
                    <TagChipsFromTagNames canonicalTagNames={featureToggleEnvironment.ExcludedTenantTags} tagIndex={tagIndex} markAsRemoved={true}/>
                </>)}
            {ExcludedTenantList({ excludedTenants: tenants.filter((tenant) => featureToggleEnvironment.ExcludedTenantIds.includes(tenant.Id)) })}
            {SegmentList({ segments: featureToggleEnvironment.Segments })}
        </span>);
};
